"use strict"; // import { createLine, createMeasurementLine, createText } from './shapes-base';
// import { getCenter } from './utils';
// import { config } from './config';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.createSharedShapes = function (plateComponents, canvas) {
  var shapes = [];
  return shapes;
};